import { Link } from "react-router-dom";
import { LI, P, UL } from "../../../../AbstractElements";
import { notificationData } from "../../../../Data/Layout/HeaderData";
import { CheckAll, Href } from "../../../../utils/Constant";

const ActivityUpdate = () => {
  return (
    <UL>
      {notificationData.map((item, i) => (
        <LI className={`border-4 bg-light-${item.color} b-t-${item.color}`} key={i}>
          <P>{item.title} 
            <span className={`font-${item.color}`}>{item.time}</span>
          </P>
        </LI>
      ))}
      <LI>
        <Link className="f-w-700" to={Href}>{CheckAll}</Link>
      </LI>
    </UL>
  );
};

export default ActivityUpdate;
